<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses">
    <b-tab title="Rating Performance VS Crowd">
      <eb-line-chart></eb-line-chart>
    </b-tab>
    <b-tab title="Portfolio Returns Crows / Your" class="e-card__content">

    </b-tab>
  </e-card>
</template>

<script>
	import ECard from "../../elements/card/card";
  import EbLineChart from "@components/widgets/lineChart/lineChart";
  import DynamicSizeMixin from '../../../mixins/dynamicSize';

  export default {
		name: "ec-performance",
    mixins: [DynamicSizeMixin],
    components: {EbLineChart, ECard},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/performance/performance.vue